import {BaseContainerModel} from '../../base-container.model';
import {bl_fi_mst_price_book_rule_line_RowClass} from '../../../dbschema/bl_fi_mst_price_book_rule_line.model';

export class PriceBookRuleLineContainerModel extends BaseContainerModel {
  bl_fi_mst_price_book_rule_line: bl_fi_mst_price_book_rule_line_RowClass = new bl_fi_mst_price_book_rule_line_RowClass();
}
